import { shallowRef, triggerRef } from 'vue'

const parentCampaignPlanId = ref(null)
const adGroupNavigationRef = shallowRef({})

export function useAdGroupNavigation () {
  const { $res } = useNuxtApp()

  return {
    adGroupNavigationRef,
    getAdGroupNavigation: () => adGroupNavigationRef.value,
    clearAdGroupNavigation () {
      adGroupNavigationRef.value = {}
      triggerRef(adGroupNavigationRef)
    },
    async fetchAdGroupNavigation (plan) {
      if (!plan?.campaignPlanId) return

      if (parentCampaignPlanId.value === plan.campaignPlanId) return

      parentCampaignPlanId.value = plan.campaignPlanId

      const response = await $res.fetch.navigation('adgroup', plan)
      if (response) {
        adGroupNavigationRef.value = {
          ...adGroupNavigationRef.value,
          [plan.campaignPlanId]: response
        }
        triggerRef(adGroupNavigationRef)
      }
    }
  }
}
